import { FC, useState } from 'react';
import { Form as FormMethods } from '@repo-level/core-front';

import { FormGroup } from 'components/form/groups/FormGroup';
import { Input } from 'components/form/Input';
import { required } from 'helpers/validators';
import { OfUnion } from 'types/common';
import { useTranslation } from 'react-i18next';
import { useFieldState } from 'informed';

export const FieldCardHolder: FC<
  OfUnion<FormMethods.MethodField>[FormMethods.MethodFieldType.CardHolder]
> = ({ fieldName, proposedValue }) => {
  const { t } = useTranslation('glossary');
  const [isFocused, setIsFocused] = useState(false);
  const fieldState = useFieldState(fieldName);

  const handleFocus = () => setIsFocused(true);
  const handleBlur = () => setIsFocused(false);

  const getPlaceholder = () => {
    if (isFocused || fieldState?.value) {
      return t('cardHolder');
    }
    return t('cardHolderDefault');
  };

  return (
    <FormGroup marginBottom={8}>
      <Input
        field={fieldName}
        id={fieldName}
        validate={required}
        initialValue={proposedValue || undefined}
        animatedPlaceholder={getPlaceholder()}
        onFocus={handleFocus}
        onBlur={handleBlur}
        validateOnBlur
      />
    </FormGroup>
  );
};
